import { Phone, Mail, MapPin } from "lucide-react";
import { Reveal } from "./Reveal";
import SectionHead from "./SectionHead";

const CARDS = [
  {
    icon: Phone,
    title: "Anrufen",
    value: "0176 32526128",
    href: "tel:+4917632526128",
    note: "Reservieren & kurzfristig fragen — besonders am Wochenende: einfach mal anrufen.",
    testid: "home-kontakt-card-phone",
  },
  {
    icon: Mail,
    title: "Schreiben",
    value: "vintagebillard@gmail.com",
    href: "mailto:vintagebillard@gmail.com",
    note: "Für Anfragen, Gruppen und alles, was nicht eilt.",
    testid: "home-kontakt-card-mail",
  },
  {
    icon: MapPin,
    title: "Vorbeikommen",
    value: "Hemelinger Heerstraße 7, 28309 Bremen",
    href: "https://www.google.com/maps/dir/?api=1&destination=Vintage+Billard,+Hemelinger+Heerstra%C3%9Fe+7,+28309+Bremen",
    note: "Buslinien 40 & 41 um die Ecke, Parkplätze vorhanden — ein Tisch findet sich immer.",
    testid: "home-kontakt-card-visit",
  },
];

export default function KontaktSection() {
  return (
    <section id="kontakt" data-testid="kontakt-section" className="bg-[#1c1512] px-6 py-24 md:px-10 md:py-36">
      <div className="mx-auto max-w-6xl">
        <SectionHead
          chapter="06"
          eyebrow="Kontakt"
          title={
            <>
              Sag einfach <span className="italic text-[#e3c988]">Bescheid.</span>
            </>
          }
        />
        <div className="mt-16 grid gap-6 md:grid-cols-3">
          {CARDS.map(({ icon: Icon, title, value, href, note, testid }, i) => (
            <Reveal key={title} delay={i * 0.1} className="h-full">
              <a
                href={href}
                target={href.startsWith("http") ? "_blank" : undefined}
                rel={href.startsWith("http") ? "noreferrer" : undefined}
                data-testid={testid}
                className="group flex h-full flex-col border border-[#241a15] bg-[#120d0b] p-8 transition-colors duration-500 hover:bg-[#241a15]"
              >
                <Icon size={28} className="text-[#c9a24a] transition-transform duration-500 group-hover:-translate-y-1" />
                <h3 className="mt-8 font-display text-2xl text-[#f4ecdd] transition-colors duration-300 group-hover:text-[#e3c988]">
                  {title}
                </h3>
                <p className="mt-3 font-display text-lg text-[#e3c988]">{value}</p>
                <p className="mt-4 text-sm leading-relaxed text-[#c9bda9]">{note}</p>
              </a>
            </Reveal>
          ))}
        </div>
        <Reveal delay={0.3}>
          <p
            className="mx-auto mt-16 max-w-2xl text-center font-display text-xl italic leading-relaxed text-[#e3c988] md:text-2xl"
            data-testid="kontakt-dropin-home"
          >
            „Oder komm einfach mal vorbei — ein Tisch findet sich immer."
          </p>
        </Reveal>
      </div>
    </section>
  );
}
